import React, { useRef, useEffect, useState } from "react";
import { motion, useAnimation } from "framer-motion";
import { ReactComponent as DropdownArrow } from "assets/icons/dropdown_arrow.svg";
import useSearchFilter from "hooks/useSearchFilter";
import useSearch from "hooks/useSearch";
import ReactDOM from "react-dom";
import { useMediaQuery } from "react-responsive";
// const FilterDropdown = ({
//   id,
//   placeholder,
//   selectedItem,
//   children,
//   dropdownStyle,
//   buttonStyle,
//   buttonTextStyle,
//   firstInputRef,
//   closeHandler,
//   Icon,
// }) => {
//   const { openFilterDropdownId, toggleFilterDropdown } = useSearchFilter();
//   const {
//     toggleFilterDropdown: togglePropertyTypeFilterDropdown,
//     isFilterDropdownOpen,
//   } = useSearch();
//   const isOpen = openFilterDropdownId === id;
//   const dropdownRef = useRef(null);
//   const buttonRef = useRef(null);
//   const controls = useAnimation();
//   const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });

//   const handleToggle = (e) => {
//     e.stopPropagation();
//     // Close the property type filter dropdown if it currently open
//     if (isFilterDropdownOpen) {
//       togglePropertyTypeFilterDropdown("searchFilter");
//     }
//     toggleFilterDropdown(id);
//   };

//   const handleClickAway = (e) => {
//     // Check if it click inside dropdown
//     if (dropdownRef.current && dropdownRef.current.contains(e.target)) {
//       return;
//     }

//     if (isOpen) {
//       toggleFilterDropdown(id);
//       // if (closeHandler) closeHandler(e);
//     }
//   };

//   // close dropdown when click away
//   useEffect(() => {
//     document.addEventListener("click", handleClickAway);

//     return () => {
//       document.removeEventListener("click", handleClickAway);
//     };
//   }, [isOpen]);

//   // apply dropdown animation
//   useEffect(() => {
//     if (isOpen) {
//       controls.start({ opacity: 1, y: 0 });
//     } else {
//       controls.start({ opacity: 0, y: -10 });
//     }
//   }, [isOpen, controls]);

//   // dropdown postion based on the button position in the window
//   useEffect(() => {
//     if (buttonRef.current && isOpen) {
//       const { top, left, width } = buttonRef.current.getBoundingClientRect();
//       setDropdownPosition({
//         top: top + window.scrollY,
//         left: left + window.scrollX,
//       });
//     }
//   }, [isOpen]);

//   // focus on the first input when dropdown is open
//   useEffect(() => {
//     if (isOpen && firstInputRef && firstInputRef.current) {
//       firstInputRef.current.focus();
//     }
//   }, [isOpen, firstInputRef]);

//   return (
//     <div className="min-w-fit" ref={dropdownRef}>
//       <div
//         ref={buttonRef}
//         style={buttonStyle}
//         className={`flex items-center justify-between min-w-fit space-x-3 px-[14px] cursor-pointer h-[42px] rounded-[8px] border border-[#F0EFFB] hover:bg-[#EAEAEA] transition-all duration-300 ease-in ${
//           isOpen ? "bg-[#EAEAEA]" : "bg-white"
//         } ${selectedItem ? "text-[#1DA1F2]" : "text-black"}`}
//         onClick={handleToggle}
//       >
//         {Icon && (
//           <div
//             className={`mt-[1px] ${
//               selectedItem ? "text-[#1DA1F2]" : "text-black"
//             }`}
//           >
//             <Icon />
//           </div>
//         )}
//         <h3
//           style={buttonTextStyle}
//           className={`font-semibold flex-shrink-0 leading-none text-[12px] ${
//             selectedItem ? "text-[#1DA1F2]" : "text-black"
//           }`}
//         >
//           {selectedItem || placeholder}
//         </h3>
//         <motion.div
//           className={`mt-[1px] ${
//             selectedItem ? "text-[#1DA1F2]" : "text-black"
//           }`}
//           animate={{ rotate: isOpen ? 180 : 0 }}
//           transition={{ duration: 0.3 }}
//         >
//           <DropdownArrow />
//         </motion.div>{" "}
//       </div>
//       {isOpen && (
//         <motion.div
//           className="absolute z-[1000] min-w-[300px] overflow-hidden mt-1 bg-white border border-[#F0EFFB] rounded-lg filter-dropdown-shadow w-full"
//           initial={{ opacity: 0, y: -10 }}
//           animate={controls}
//           transition={{ duration: 0.3 }}
//           style={{
//             top: dropdownPosition.top,
//             left: dropdownPosition.left,
//             ...dropdownStyle,
//           }}
//           onClick={(e) => e.stopPropagation()} // Prevent dropdown close when clicked within dropdown
//         >
//           {children}
//         </motion.div>
//       )}
//     </div>
//   );
// };

const FilterDropdown = ({
  id,
  placeholder,
  selectedItem,
  children,
  dropdownStyle,
  buttonStyle,
  buttonTextStyle,
  firstInputRef,
  closeHandler,
  Icon,
}) => {
  const { openFilterDropdownId, toggleFilterDropdown } = useSearchFilter();
  const {
    toggleFilterDropdown: togglePropertyTypeFilterDropdown,
    isFilterDropdownOpen,
  } = useSearch();

  const isOpen = openFilterDropdownId === id;
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);
  const controls = useAnimation();
  const lg = useMediaQuery({ query: "(min-width: 1024px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 640px)" });

  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });

  // Toggle the dropdown open/close
  const handleToggle = (e) => {
    e.stopPropagation();
    if (isFilterDropdownOpen) {
      togglePropertyTypeFilterDropdown("searchFilter");
    }
    toggleFilterDropdown(id);
  };

  // Close dropdown when clicking outside
  const handleClickAway = (e) => {
    // If we're inside a mobile filter dialog, allow clicks inside the dropdown
    if (
      isMobile &&
      dropdownRef.current &&
      dropdownRef.current.contains(e.target)
    ) {
      e.stopPropagation(); // Prevent event bubbling to modal backdrop
      return;
    }

    // Only close if click is outside the dropdown
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      if (isOpen) {
        toggleFilterDropdown(id);
      }
    }
  };

  // Add event listener to close the dropdown when clicking away
  useEffect(() => {
    document.addEventListener("click", handleClickAway);
    return () => {
      document.removeEventListener("click", handleClickAway);
    };
  }, [isOpen]);

  // Apply dropdown animation (fade in/out)
  useEffect(() => {
    if (isOpen) {
      controls.start({ opacity: 1, y: 0 });
    } else {
      controls.start({ opacity: 0, y: -10 });
    }
  }, [isOpen, controls]);

  // Set dropdown position based on button's position and update on scroll
  const updateDropdownPosition = () => {
    if (buttonRef.current && isOpen) {
      const { top, left, width } = buttonRef.current.getBoundingClientRect();
      setDropdownPosition({
        top: top + buttonRef.current.offsetHeight,
        left: left,
      });
    }
  };

  // Update position on scroll
  useEffect(() => {
    if (isOpen) {
      updateDropdownPosition();

      // // Add scroll event listener to update position when scrolling
      // window.addEventListener("scroll", updateDropdownPosition, true);

      // // Also add resize listener for any layout changes
      window.addEventListener("resize", updateDropdownPosition);

      return () => {
        //   window.removeEventListener("scroll", updateDropdownPosition, true);
        window.removeEventListener("resize", updateDropdownPosition);
      };
    }
  }, [isOpen]);

  // Focus on first input when dropdown is opened
  useEffect(() => {
    if (isOpen && firstInputRef && firstInputRef.current) {
      firstInputRef.current.focus();
    }
  }, [isOpen, firstInputRef]);

  return (
    <div className="min-w-fit" ref={dropdownRef}>
      <div
        ref={buttonRef}
        style={buttonStyle}
        className={`flex items-center justify-between min-w-fit space-x-3 px-[14px] cursor-pointer h-[42px] rounded-[8px] border border-[#F0EFFB] hover:bg-[#EAEAEA] transition-all duration-300 ease-in ${
          isOpen ? "bg-[#EAEAEA]" : "bg-white"
        } ${selectedItem ? "text-[#1DA1F2]" : "text-black"}`}
        onClick={handleToggle}
      >
        {Icon && (
          <div
            className={`mt-[1px] ${
              selectedItem ? "text-[#1DA1F2]" : "text-black"
            }`}
          >
            <Icon />
          </div>
        )}
        <h3
          style={buttonTextStyle}
          className={`font-semibold flex-shrink-0 leading-none text-[12px] ${
            selectedItem ? "text-[#1DA1F2]" : "text-black"
          }`}
        >
          {selectedItem || placeholder}
        </h3>
        <motion.div
          className={`mt-[1px] ${
            selectedItem ? "text-[#1DA1F2]" : "text-black"
          }`}
          animate={{ rotate: isOpen ? 180 : 0 }}
          transition={{ duration: 0.3 }}
        >
          <DropdownArrow />
        </motion.div>
      </div>

      {/* Render the dropdown using React Portal into document.body */}
      {isOpen &&
        ReactDOM.createPortal(
          <motion.div
            className="absolute z-[9999] lg:z-[50] min-w-[300px] overflow-hidden mt-1 bg-white border border-[#F0EFFB] rounded-lg filter-dropdown-shadow w-full"
            initial={{ opacity: 0, y: -10 }}
            animate={controls}
            transition={{ duration: 0.3 }}
            style={{
              position: "fixed", // Use fixed positioning for mobile
              top: dropdownPosition.top,
              left: dropdownPosition.left,
              ...dropdownStyle,
            }}
            onClick={(e) => {
              e.stopPropagation(); // Prevent dropdown close when clicked within dropdown
              if (isMobile) {
                // Prevent event from bubbling up to dialog backdrop in mobile
                e.nativeEvent.stopImmediatePropagation();
              }
            }}
          >
            {children}
          </motion.div>,
          document.body // Append the dropdown to the body, avoiding overflow issues
        )}

      {/* {isOpen && lg ? (
        ReactDOM.createPortal(
          <motion.div
            className="absolute z-[51] lg:z-[50] min-w-[300px] overflow-hidden mt-1 bg-white border border-[#F0EFFB] rounded-lg filter-dropdown-shadow w-full"
            initial={{ opacity: 0, y: -10 }}
            animate={controls}
            transition={{ duration: 0.3 }}
            style={{
              position: "absolute", // Ensures the dropdown isn't constrained by swiper overflow
              top: dropdownPosition.top,
              left: dropdownPosition.left,
              ...dropdownStyle,
            }}
            onClick={(e) => e.stopPropagation()} // Prevent dropdown close when clicked within dropdown
          >
            {children}
          </motion.div>,
          document.body // Append the dropdown to the body, avoiding overflow issues
        )
      ) : (
        <motion.div
          className="absolute z-[51] lg:z-[50] min-w-[300px] overflow-hidden mt-1 bg-white border border-[#F0EFFB] rounded-lg filter-dropdown-shadow w-full"
          initial={{ opacity: 0, y: -10 }}
          animate={controls}
          transition={{ duration: 0.3 }}
          style={{
            position: "absolute", // Ensures the dropdown isn't constrained by swiper overflow
            top: dropdownPosition.top,
            left: dropdownPosition.left,
            ...dropdownStyle,
          }}
          onClick={(e) => e.stopPropagation()} // Prevent dropdown close when clicked within dropdown
        >
          {children}
        </motion.div>
      )} */}
    </div>
  );
};

export default FilterDropdown;
